import type { SwitchProps } from '@_/ui';
import type { FormComponentProps } from './types.ts';
import { Switch } from '@_/ui';
import { useFieldContext } from './BaseForm.ts';
import { useMergeHandleChangeAndBlur, usePropsFromField } from './utils.ts';

export function FormSwitch(props: FormComponentProps<Omit<SwitchProps, 'onChange' | 'value'>>) {
  const field = useFieldContext<boolean>();

  const handleChangeAndBlur = useMergeHandleChangeAndBlur(field.handleChange, field.handleBlur);

  return (
    <Switch
      key={field.name}
      {...usePropsFromField(props, field)}
      onChange={handleChangeAndBlur}
      value={field.state.value}
    />
  );
}
